/* eslint-disable import/prefer-default-export */
export const HIDE_SMALL_BALANCES_KEY = 'hide_small_balances';
